import { enqueueSnackbar } from '../redux/notifier/notifierActions';
import store from '../store';

const extractDomain = (inputStr) => {
  const cleanedInputStr = inputStr.replace(/[()]/g, '').trim();

  const pattern = /(?:\d+:)?\s*(?:https?:\/\/)?(?:www\d?\.)?([a-zA-Z0-9.-]+)/;

  const match = cleanedInputStr.match(pattern);

  if (match) {
    return match[1];
  } else {
    return null;
  }
};

const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

const openDomain = (domain) => {
  try {
    const extractedDomain = extractDomain(domain);

    if (!extractedDomain) throw new Error();
    const url = extractedDomain.match(/^(https?|ftp):\/\//) ? extractedDomain : `http://${extractedDomain}`;

    const isValid = isValidUrl(url);

    if (isValid) {
      window.open(url, '_blank');
    } else {
      throw new Error();
    }
  } catch (error) {
    store.dispatch(
      enqueueSnackbar({
        message: `couldntOpenThisWebsite`,
        options: {
          variant: 'warning',
        },
      }),
    );
  }
};

export default openDomain;
